import React, { useState } from "react";

const AlphaherdAccordionCard = ({ accordions }) => {
  const [collapse, setCollapse] = useState(false);
  const toggle = (index) => {
    if (collapse === index) {
      return setCollapse(null);
    }
    setCollapse(index);
  };
  return (
    <div className="accordion_lists">
      {accordions.map((d) => (
        <div key={d.id} className="accordion_card">
          <div className="title" onClick={() => toggle(d.id)}>
            <h2>{d.title}</h2>
            <span>{collapse === d.id ? "-" : "+"}</span>
          </div>
          {collapse === d.id ? (
            <div className="content">
              <p>{d.text}</p>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default AlphaherdAccordionCard;
